import { state } from '@/store/multiProductSelection/state';
import { actions } from '@/store/multiProductSelection/actions';
import { mutations } from '@/store/multiProductSelection/mutations';
import { getters } from '@/store/multiProductSelection/getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export { state, mutations, actions, getters };
